import React, {useRef} from "react";
import {StyledBackgroundImage} from "./StyledBgImage";
import {useFocalPoint} from "../../framework/hooks/useFocalPoint";

const BackgroundImage = ({
                           source,
                           onLoad,
                           children,
                           useFocalPoint: focal,
                           HeroCurvedTextArea,
                           smallBorderRadius,
                           alt
                         }) => {
  const refBgImage = useRef();
  const {isCropped, coordinates} = useFocalPoint(source);

  const addImageAttributes = alt && alt.length > 0 ? {role: "img", "aria-label": alt} : {"aria-hidden": "true"};
  return (
    <StyledBackgroundImage
      ref={refBgImage}
      fadeIn={onLoad}
      bgImage={source}
      isCropped={isCropped}
      coordinates={focal != undefined && coordinates}
      HeroCurvedTextArea
      smallBorderRadius={smallBorderRadius}
      {...addImageAttributes}
    >
      {children != undefined && children}
    </StyledBackgroundImage>
  );
};

export default BackgroundImage;
